const $$splitComponentImporter = () => import('/home/runner/work/vision-lab-frontend/vision-lab-frontend/src/routes/_authenticated/_app/supervisor/team/route.tsx?tsr-split=component');
import { lazyRouteComponent } from '@tanstack/react-router';
import { requireCapabilities } from '@/features/authentication/lib/routeGuards';
import { createFileRoute } from '@tanstack/react-router';
export const Route = createFileRoute('/_authenticated/_app/supervisor/team')({
  beforeLoad: requireCapabilities(has => has('metadata-library.organization.read')),
  component: lazyRouteComponent($$splitComponentImporter, 'component')
});